import request from '@/utils/request'

// 查询代理商收入
export function qryAgentIncome(query) {
  const _query = {}
  _query.pageIndex = query.pageIndex
  _query.pageSize = query.pageSize
  if (query.time) {
    _query.startTime = query.time[0]
    _query.endTime = query.time[1]
  }
  if (query.userName) {
    _query.userName = query.userName
  }
  return request({
    url: '/api/financeInfo/qryAgentIncome',
    method: 'post',
    params: _query
  })
}
// 查询场地方收入
export function qryFieldIncome(query) {
  const _query = {}
  _query.pageIndex = query.pageIndex
  _query.pageSize = query.pageSize
  if (query.time) {
    _query.startTime = query.time[0]
    _query.endTime = query.time[1]
  }
  if (query.userName) {
    _query.userName = query.userName
  }
  return request({
    url: '/api/financeInfo/qryFieldIncome',
    method: 'post',
    params: _query
  })
}

// 场地、代理收入详情
export function incomeDetail(query) {
  return request({
    url: '/api/financeInfo/incomeDetail',
    method: 'post',
    params: query
  })
}

// POST /api/financeInfo/qryFieldInfoIncome 查询场地收入
export function qryFieldInfoIncome(params) {
  return request({
    url: '/api/financeInfo/qryFieldInfoIncome',
    method: 'post',
    params
  })
}

// POST /api/financeInfo/exportFieldIncomeExcel 导出场地收入统计信息
export function exportFieldIncomeExcel(params) {
  return request({
    url: '/api/financeInfo/exportFieldIncomeExcel',
    method: 'post',
    params
  })
}

